import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { flashSaleSeasonalWarehouseSaleIsOn } from "@faire/retailer-visitor-shared/settings/getSettingSeasonalWarehouseSale";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { useMemo } from "react";
export var useFlashSale = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var retailer = useRetailer().retailer;
    var _useNationality = useNationality(), isAmerican = _useNationality.isAmerican, retailerCountry = _useNationality.retailerCountry;
    var userCanPlaceOrder = useUserStore([
        "userCanPlaceOrder"
    ]).userCanPlaceOrder;
    var _useRetailerStore = useRetailerStore([
        "showFlashSales",
        "showFlashSalesAsUnavailable",
        "showWarehouseFlashSale"
    ]), showFlashSalesControl = _useRetailerStore.showFlashSales, showFlashSalesAsUnavailableControl = _useRetailerStore.showFlashSalesAsUnavailable, showWarehouseFlashSaleControl = _useRetailerStore.showWarehouseFlashSale;
    var showFlashSales = useMemo(function() {
        if (!userCanPlaceOrder) {
            return false;
        }
        return !!retailer && !retailer.hide_redistribution_channels && (isAmerican || retailerCountry === undefined);
    }, [
        userCanPlaceOrder,
        retailer,
        isAmerican,
        retailerCountry
    ]);
    /**
     * Whether to couple the fact that we don't show FS/M&M (see above)
     * with a different UI that still exposes entry-points and a sorry message.
     */ var showFlashSalesAsUnavailable = useMemo(function() {
        if (!userCanPlaceOrder) {
            return false;
        }
        return !!(retailer === null || retailer === void 0 ? void 0 : retailer.hide_redistribution_channels) && !!(retailer === null || retailer === void 0 ? void 0 : retailer.show_flash_sales_mix_and_match_as_unavailable) && (isAmerican || retailerCountry === undefined);
    }, [
        userCanPlaceOrder,
        retailer,
        isAmerican,
        retailerCountry
    ]);
    var showWarehouseFlashSale = showFlashSales && flashSaleSeasonalWarehouseSaleIsOn();
    if (shouldUseHooksMigration) {
        return {
            showFlashSales: showFlashSales,
            showFlashSalesAsUnavailable: showFlashSalesAsUnavailable,
            showWarehouseFlashSale: showWarehouseFlashSale
        };
    }
    return {
        showFlashSales: showFlashSalesControl,
        showFlashSalesAsUnavailable: showFlashSalesAsUnavailableControl,
        showWarehouseFlashSale: showWarehouseFlashSaleControl
    };
};
